"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrafficModel = exports.ETA_INTERVAL = void 0;
exports.ETA_INTERVAL = 1000 * 60 * 1; // Every 1 minute
var TrafficModel;
(function (TrafficModel) {
    TrafficModel["BEST_GUESS"] = "best_guess";
})(TrafficModel = exports.TrafficModel || (exports.TrafficModel = {}));
